/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KeyType } from '../../models/key-type';
import { ServiceProviderOrganizationAdmins } from '../../models/service-provider-organization-admins';

export interface GetServiceProviderOrganizationAdmins$Params {

/**
 * The organization key
 */
  organizationKey: KeyType;
}

export function getServiceProviderOrganizationAdmins(http: HttpClient, rootUrl: string, params: GetServiceProviderOrganizationAdmins$Params, context?: HttpContext): Observable<StrictHttpResponse<ServiceProviderOrganizationAdmins>> {
  const rb = new RequestBuilder(rootUrl, getServiceProviderOrganizationAdmins.PATH, 'get');
  if (params) {
    rb.path('organizationKey', params.organizationKey, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ServiceProviderOrganizationAdmins>;
    })
  );
}

getServiceProviderOrganizationAdmins.PATH = '/service-provider/organizations/{organizationKey}/organization-admins';
